export function createWidgetPluginExports(widgetPluginService) {
  return {
    set isWidgetPlugin(value) {
      widgetPluginService.setIsWidgetPlugin(value);
    },
    set members(value) {
      widgetPluginService.setMembers(value);
    },
    onMembersAreaEvent(event) {
      widgetPluginService.notifyMembersAreaEventListeners(event);
    }
  };
}
//# sourceMappingURL=widget-plugin-exports.js.map